<template>
  <div
    @click="() => {open=true}">
    <MenuItem
      v-if="mode==='list'"
      slot="activator"
      class="h11-links"
      data-qa="item-review-item-website"
      icon="share"
      :label="$t('Purchasing.ToShare')"
      @click.stop="open = true"/>
    <sButton
      v-else-if="mode==='button'"
      slot="activator"
      data-qa="share-btn"
      icon="share"
      type="text"
      @click.stop="open = true">
      {{ $t('Purchasing.ToShare') }}
    </sButton>
    <TooltipedBtn
      v-else-if="mode === 'icon'"
      data-qa="share-btn"
      :disabled="!mutableOptions.id"
      icon="share"
      small-btn
      :text="$t('Purchasing.ToShare')"
      @click="open = true"/>
    <DialogTemplateToolkit
      class-name="add-agreeing"
      :dialog="open"
      first_btn="Tenders.SendForApproval"
      :second_btn="$t('Common.Close')"
      :title="$t('Purchasing.ToShare')"
      without_first_btn
      @close="closeModal">
      <template #card-text>
        {{ mutableOptions.shareLabel }} <b>#{{ mutableOptions.number }} {{ mutableOptions.title }}</b>
        <div
          v-if="mutableOptions.showParticipantsLink"
          class="row-data">
          <span>
            <sIcon
              class="mr-2"
              type="world"/>
            {{ $t('Tenders.shareToParticipants') }} </span>
          <sInput
            data-qa="link-public"
            readonly
            :value.sync="siteLink"/>
          <TooltipedBtn
            class="my-auto"
            data-qa="btn-copy-public"
            icon="copy"
            small-btn
            :text="$t('Common.Copy')"
            @click="copyValues(siteLink)"/>
        </div>
        <div
          v-if="isEditPage && $acl.check('isAdmin')"
          class="row-data">
          <span>
            <sIcon
              class="mr-2"
              type="link"/>
            {{ $t('Common.Current') }}
          </span>
          <sInput
            data-qa="link-current"
            readonly
            :value.sync="currentHref"/>
          <TooltipedBtn
            class="my-auto"
            data-qa="btn-copy-current"
            icon="copy"
            small-btn
            :text="$t('Common.Copy')"
            @click="copyValues(currentHref)"/>
        </div>
        <div class="row-data">
          <span>
            <sIcon
              class="mr-2"
              type="link"/>
            {{ $t('Tenders.shareToColleagues') }} </span>
          <sInput
            data-qa="link-site-link-org"
            readonly
            :value="siteLinkOrg"/>
          <TooltipedBtn
            class="my-auto"
            data-qa="btn-copy-site-link-org"
            icon="copy"
            small-btn
            :text="$t('Common.Copy')"
            @click="copyValues(siteLinkOrg)"/>
        </div>
      </template>
    </DialogTemplateToolkit>
  </div>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { componentOptions} from 'mixins'

export default {
  name: 'ShareBlock',
  mixins: [ componentOptions],
  data() {
    return {
      open: false,
      mutableOptions: {
        id: null,
        number: null,
        title: null,
        shareLabel: this.$t('Tenders.shareLabel'),
        showParticipantsLink: true,
        participantsLink: null,
        routeLinkOrg: 'tenderitem'
      },
    }
  },
  methods: {
    copyValues(value) {
      navigator.clipboard.writeText(value)
      this.$notice.info({
        title: this.$t('Common.Copy'),
        message: this.$t('Tenders.linkCopied'),
        duration: 10
      })
      this.closeModal()
    },
    closeModal() {
      this.open = false
      this.$emit('closeModal')
    }
  },
  computed: {
    siteLink() {
      if (this.mutableOptions.participantsLink) {
        return this.mutableOptions.participantsLink
      }
      const href = this.$i18n.locale === 'uk'
        ? 'komertsiyni-torgy'
        : 'en/commercial-trades'
      return `${window.config?.SmarttenderUrl}${href}/${this.mutableOptions.id}/`
    },
    isEditPage() {
      return this.$route.name === 'editTender'
    },
    currentHref() {
      return window.location.href
    },
    siteLinkOrg() {
      if (this.isEditPage || this.mutableOptions.id) {
        const params = {
          locale: this.$route.params.locale,
          org: this.$route.params.org,
          id: this.mutableOptions.id ?? this.$route.params.id
        }

        const resolvedUrl = this.$router.resolve({ name: this.mutableOptions.routeLinkOrg , params })
        return window.location.origin + resolvedUrl.href
      }
      return window.location.origin + window.location.pathname
    }
  },
  components: {
    MenuItem,
    TooltipedBtn,
    DialogTemplateToolkit
  },
  props: {
    list: {
      type: Boolean
    },
    mode: {
      type: String,
      default: 'button',
      validator: function (value) {
        const correct = ['button', 'list', 'icon'].indexOf(value) !== -1
        return correct
      },
    }
  },
}
</script>
<style scoped lang="scss">
.row-data {
  line-height: 36px;
  display: grid;
  grid-template-columns: 155px auto 50px;
  margin-top: 25px;
  @media (max-width: 640px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &>*:nth-child(2) {
      width: calc(100% - 35px);
    }
  }
}
</style>
